import type Handsontable from 'handsontable';

/** A cell the user typed, pasted, or cleared. */
export interface CsvCellEdit {
  /** The row's index in the table (`draft.rows`), not its on-screen position. */
  rowIndex: number;
  header: string;
  value: string;
}

/** A cell's value as CSV text; a cleared cell (null/undefined) is empty. */
export function csvCellText(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return '';
}

/**
 * Handsontable's `afterChange` reports visual rows. Once the column filters
 * hide rows, the second visible row can be the table's sixth, so each change is
 * mapped back to its underlying row before it is keyed as an edit.
 */
export function csvCellEditsFromChanges(
  changes: Handsontable.CellChange[],
  toPhysicalRow: (visualRow: number) => number | null,
): CsvCellEdit[] {
  const edits: CsvCellEdit[] = [];
  for (const [visualRow, prop, , newValue] of changes) {
    // Columns are header-keyed; a numeric prop would be an unmapped column.
    if (typeof prop !== 'string') continue;
    const rowIndex = toPhysicalRow(visualRow);
    if (rowIndex === null) continue;
    edits.push({ rowIndex, header: prop, value: csvCellText(newValue) });
  }
  return edits;
}
